import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
}
const options: PricingOption[] = [{
  id: 'megapack',
  emoji: '📘',
  title: 'MEGAPACK BOXEO LISTO',
  description: '6 tomos + 6 bonos',
  originalPrice: 'USD $24.90',
  price: 'USD $13.90',
  ctaText: '→ QUIERO MI MEGAPACK BOXEO LISTO',
  ctaHref: 'https://docentes2.edulabs.online/cart/43257056985206:1'
}, {
  id: 'elite',
  emoji: '🏆',
  title: 'MEGAPACK + MÉTODO GYM LLENO',
  description: '6 tomos + 6 bonos + Método Gym Lleno 2026™',
  originalPrice: 'USD $33.90',
  price: 'USD $19.90',
  ctaText: '→ SÍ, QUIERO EL MEGAPACK + MÉTODO GYM LLENO',
  ctaHref: 'https://docentes2.edulabs.online/cart/43257060098166:1',
  isFeatured: true,
  savings: 'AHORRAS USD $14'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('elite');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-10 sm:py-16 px-4" data-id="element-157">
      <div className="max-w-xl mx-auto" data-id="element-158">
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1 sm:mb-3" data-id="element-159">
          🛒 ELIGE TU{' '}
          <span className="text-[#F97316]" data-id="element-160">MEGAPACK BOXEO LISTO:</span>
        </h2>
        <p className="text-gray-300 text-center text-xs sm:text-base mb-5 sm:mb-10" data-id="element-161">
          Las dos opciones incluyen los 6 bonos estratégicos completos
        </p>

        <div className="space-y-3 sm:space-y-4 mb-5 sm:mb-8" data-id="element-162">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl sm:rounded-2xl p-4 sm:p-6 transition-all ${isFeatured && isSelected ? 'border-2 border-[#F97316] bg-[#0d0700] shadow-[0_0_30px_rgba(249,115,22,0.15)]' : isFeatured ? 'border-2 border-[#F97316]/50 bg-[#0d0700]' : isSelected ? 'border-2 border-[#F97316] bg-[#0a0a0a]' : 'border border-white/10 bg-[#0a0a0a]'}`} data-id="element-163">
                <div className="flex items-center gap-3 sm:gap-4" data-id="element-164">
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#F97316]' : 'border-white/30'}`} data-id="element-165">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-[#F97316]" data-id="element-166" />}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-167">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-168">
                      <span className="text-lg" data-id="element-169">{option.emoji}</span>
                      <span className="text-white font-black text-base sm:text-lg" data-id="element-170">
                        {option.title}
                      </span>
                    </div>

                    {isFeatured && <div className="flex items-center gap-2 mt-1.5 sm:mt-2 flex-wrap" data-id="element-171">
                        <span className="bg-[#F97316] text-black text-[11px] sm:text-xs font-black px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full" data-id="element-172">
                          ⭐ MÁS ELEGIDA
                        </span>
                        {option.savings && <span className="bg-[#F97316]/20 text-[#F97316] text-[11px] sm:text-xs font-bold px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full border border-[#F97316]/40" data-id="element-173">
                            {option.savings}
                          </span>}
                      </div>}

                    <p className="text-gray-400 text-sm mt-1" data-id="element-174">
                      {option.description}
                    </p>
                  </div>

                  <div className="text-right flex-shrink-0" data-id="element-175">
                    <div className="text-gray-400 line-through text-xs sm:text-sm" data-id="element-176">
                      {option.originalPrice}
                    </div>
                    <div className={`font-black text-2xl sm:text-3xl ${isFeatured ? 'text-[#F97316]' : 'text-white'}`} data-id="element-177">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        <div className="space-y-3" data-id="element-178">
          <a href={selectedOption.ctaHref} className="btn-green-pulse block w-full text-center bg-[#F97316] font-black text-base sm:text-xl py-4 sm:py-5 rounded-xl sm:rounded-2xl hover:bg-[#FB923C] transition-colors text-[#FFFFFF]" data-id="element-179">
            {selectedOption.ctaText}
          </a>
          <p className="text-gray-400 text-xs text-center" data-id="element-180">
            💳 El cobro se realizará en la moneda local de tu país al tipo de
            cambio vigente.
          </p>
        </div>

        <p className="text-gray-400 text-xs sm:text-sm text-center mt-3 sm:mt-4 italic" data-id="element-181">
          {selected === 'elite' ? 'La más elegida por entrenadores que quieren profesionalizarse y cobrar lo que realmente merecen' : 'El sistema completo de clases para entrenadores de boxeo'}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-300 mt-6 sm:mt-8 bg-[#0a0a0a] border border-[#F97316]/20 rounded-xl py-3 sm:py-4 px-4 sm:px-6" data-id="element-182">
          <span data-id="element-183">🔒 Pago 100% seguro</span>
          <span data-id="element-184">⚡ Acceso en 5 minutos</span>
          <span data-id="element-185">🛡️ Garantía 7 días sin preguntas</span>
          <span className="w-full text-center mt-1 sm:w-auto sm:mt-0" data-id="element-186">
            💳 Tarjeta de crédito · Débito · PayPal · Pago local según tu país
          </span>
        </div>
      </div>
    </section>;
}